import type { Links, PaginationDirection } from './types';

export function parseLink(direction: PaginationDirection, links?: Links) {
  const linkParams = getSearchParams(links?.[direction]?.href);

  const offsetParam = linkParams?.get('offset');

  return {
    offset: offsetParam ?? '0',
  };
}

function getSearchParams(path?: string) {
  if (!path) {
    return null;
  }

  return new URL(`${window.location.protocol}//${window.location.host}${path}`).searchParams;
}
